
class ConnectingSeriesArgs {
    //
    //// Primary configs - lays out the arc sizes, steps, sides of
    //   the shape length (size) 
    //
    // arc       - Arr[Number] {2} 
    //              The size of the outer part of the shape, 0-1.
    //              Since there are two points of contact use arr (2)
    //              determines sweep size.
    // step       - Arr[Number] {2} 
    //              How much to move along the outer shape before
    //              drawing next arc. Defaults to the same value as size.
    // size       - Arr[Number] {2} 
    //              distance to draw the shape.  
    //              Will do two sets of point calcs so sizing does not 
    //              need to be symmetric. 
    // gap        - The offset between the contact points. defaults to 0.5  
    //
    //// How many to produce, what overall size
    //
    // arcAdjust  - Arr[Number] {2} Normally the arc will draw full size
    //              but you may want to configure this.
    // maxConnect - The max number of connecting shapes to make, defaults 
    //              to 0 (which will calculate on full rotation)
    //
    //// Grow/shrink attenuations params. Applied after each individual 
    //   shape so will continually change.  
    //   positive grows, negative shirnks.  
    //
    // arcChange    - [2] Optional values to shrink/grow the outer shape size.
    //                Defaults to none (0). Negative grows, pos shrinks.
    // stepChange   - [2] Optional values to shrink/grow step between shapes.
    // sizeChange   - [2] Optional value to shrink/grow the shape
    //                   length between the points (not the end arcs, 
    //                   the connecting lines)
    //
    // arcChangeRepeat - n x 2 - repeat some sort of grow/shrink of the arcs
    // stepChangeRepeat - n x 2 - repeat some sort of grow/shink of the steps
    //

    constructor(
        arc, 
        step,
        size,
        gap
    ) {
        // Base args that will be adjusted by the others
        this.arc = arc
        this.size = size
        this.step = step
        this.gap = gap


        // Adjusting arguments
        this.connectPoints = false
        this.maxConnect = 1 / arc[0]
        this.arcAdjust = [1, 1]

        this.arcChange = [0, 0]
        this.stepChange = [0, 0]
        this.sizeChange = [0, 0]

        // Repeated - meaning they do not compound, but can do some
        // repeating adjustment to arc/step sizes
        this.arcChangeRepeat = [[1, 1]]
        this.stepChangeRepeat = [[1, 1]]
    }

    setMaxConnect(maxConnect) {
        this.maxConnect = maxConnect
        return this
    }

    setArcAdjust(adjust) {
        this.arcAdjust = adjust
        return this
    }

    setArcChange(arcChange) {
        this.arcChange = arcChange
        return this
    }

    setStepChange(stepChange) {
        this.stepChange = stepChange
        return this
    }

    setSizeChange(sizeChange) {
        this.sizeChange = sizeChange
        return this
    }

    setArcChangeRepeat(repeats) {
        this.arcChangeRepeat = repeats
        return this
    }

    setStepChangeRepeat(repeats) {
        this.stepChangeRepeat = repeats
        return this
    }

    setConnectPoints(connect) {
        this.connectPoints = connect
        return this
    }
}

export { ConnectingSeriesArgs }
